/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 *
 * Mirrors Fireball.Ui/src/authConfig.ts. The clientId is a literal (not an env
 * read) to match the hardcoded authority: the app registration is fixed and
 * shared, with localhost:5173 and ui.{dev,test,stage}.bridgespecialty.com
 * already registered as SPA redirect URIs.
 */
export const msalConfig = {
	auth: {
		clientId: '822e3250-3423-42c4-82f3-86e97801ed83',
		authority:
			'https://login.microsoftonline.com/f1289cc5-8456-4f28-8eab-700d1300fc5d',
		redirectUri: '/',
		postLogoutRedirectUri: '/',
	},
	cache: {
		cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
		storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
	},
};

/**
 * Scopes requested at login. OIDC scopes only — this app authenticates with the
 * id token (redirect flow), matching Fireball.Ui's account.idToken usage.
 */
export const loginRequest = {
	scopes: ['openid', 'profile', 'email'],
};

/**
 * The shared MSAL instance. Construction is synchronous and side-effect-free;
 * initialize(), handleRedirectPromise(), the redirect login gate, and the
 * window.fetch bearer-token patch are wired by the app shell (task [3.1]) and
 * the fetch-patch HTTP layer (task [2.2]) respectively — not here.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
